import React from "react";
import styles from "./styles.module.scss";

const Header = ({ children, title }) => {
  return (
    <h2 data-step-title={title} className={styles["heading-increment"]}>
      {children}
    </h2>
  );
};

export default Header;
